const baseUrl = '__BASEURL__'

export const environment = {
  auth0Config: {
    clientId: '__AUTH0CONFIGCLIENTID__',
    domain: '__AUTH0CONFIGDOMAIN__',
    responseType: '__AUTH0CONFIGRESPONSETYPE__',
    audience: '__AUTH0CONFIGAUDIENCE__',
    redirectUrl: '__AUTH0CONFIGREDIRECTURL__',
    scope: '__AUTH0CONFIGSCOPE__',
    logoutUrl: '__AUTH0CONFIGLOGOUTPAGE__',
  },
  production: true,
  masterKeyApiUrl: baseUrl,
  flags: {
    isAlohomora: true,
    canMinimize: false,
    logging: false,
    autoReload: true,
    hideTMKGenerate: '__HIDETMKGENERATE__',
  },
  appInsightsCorrelationDomains: '__KEYINGAPIDOMAIN__',
  appInsightsInstrumentationKey: '__APPINSIGHTSINSTRUMENTATIONKEY__',
}
